import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';
import { Flex, Tooltip } from 'antd';
import { trb } from '../../Utilities';

interface IProps {
  title: string;
  isVOP: boolean;
}

export const VOPBulkFilesStatus = ({ title, isVOP }: IProps) => {
  return (
    <Flex
      gap={8}
      align="center"
    >
      <div className="text-truncate">{title}</div>
      <Tooltip
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: trb(`VOPBulkStatus.${isVOP ? 'True' : 'False'}`),
            }}
          />
        }
      >
        {isVOP ? <CheckCircleFilled className="text-primary" /> : <WarningFilled className="text-orange" />}
      </Tooltip>
    </Flex>
  );
};
